"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Close_1 = tslib_1.__importDefault(require("@material-ui/icons/Close"));
const style_1 = tslib_1.__importDefault(require("../utils/style"));
const Icons_1 = require("src/components/Icons");
function ModelInfoModal({ open, onClose, type, projectInfo, savedDetails, description }) {
    const styles = style_1.default();
    const handleCopy = () => {
        const text = JSON.stringify(savedDetails.dataformat_for_inference, null, 2);
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text)
                .then(() => console.log("Text copied."))
                .catch(err => console.error("Failed to copy: ", err));
        }
        else {
            console.error("Clipboard API not supported");
        }
    };
    return (react_1.default.createElement(core_1.Modal, { open: open, onClose: onClose, closeAfterTransition: true, BackdropComponent: core_1.Backdrop, BackdropProps: { timeout: 500 } },
        react_1.default.createElement(core_1.Fade, { in: open },
            react_1.default.createElement(core_1.Box, { sx: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 700,
                    bgcolor: 'background.paper',
                    border: '0.5px solid #000',
                    boxShadow: 24,
                    borderRadius: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '80vh',
                    overflow: 'auto',
                } },
                react_1.default.createElement(core_1.Box, { sx: {
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: '#fff',
                        padding: 5,
                        borderBottom: '1px solid #ddd',
                        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                    } },
                    react_1.default.createElement(core_1.Typography, { variant: "h6", component: "h2", style: {
                            fontWeight: 'bold',
                            fontSize: 24,
                            color: "#3C4257",
                            paddding: "24px 16px 24px 32px"
                        } }, type === "afterSaved" ? "Model Info for Inference" : "Model Info"),
                    react_1.default.createElement(core_1.IconButton, { edge: "end", color: "inherit", onClick: onClose, "aria-label": "close" },
                        react_1.default.createElement(Close_1.default, null))),
                react_1.default.createElement(core_1.Box, { sx: {
                        width: '100%',
                        padding: 26,
                        borderBottomLeftRadius: 8,
                        borderBottomRightRadius: 8,
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '32px',
                    } },
                    type === "afterSaved" &&
                        react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, style: { flexDirection: "row" } },
                            react_1.default.createElement(core_1.Grid, { item: true, xs: 4, className: styles.labelText },
                                react_1.default.createElement(core_1.Typography, null, "Project Name"),
                                react_1.default.createElement(core_1.Typography, { className: styles.valueText }, projectInfo && projectInfo.projectname)),
                            react_1.default.createElement(core_1.Grid, { item: true, xs: 4, className: styles.labelText },
                                react_1.default.createElement(core_1.Typography, null, "Problem Type"),
                                react_1.default.createElement(core_1.Typography, { className: styles.valueText }, projectInfo && projectInfo.problemtype)),
                            react_1.default.createElement(core_1.Grid, { item: true, xs: 4, className: styles.labelText },
                                react_1.default.createElement(core_1.Typography, null, "Version"),
                                react_1.default.createElement(core_1.Typography, { className: styles.valueText }, projectInfo && projectInfo.version_name))),
                    type === "viewDashboard" && (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, mb: 2 }, Object.entries(projectInfo) && Object.entries(projectInfo).map(([key, value], index) => (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, key: key },
                        react_1.default.createElement(core_1.Box, { sx: { textAlign: 'left' }, className: styles.labelText },
                            react_1.default.createElement(core_1.Typography, null, key.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase())),
                            react_1.default.createElement(core_1.Typography, { className: styles.valueText }, typeof value === 'number' && !Number.isInteger(value)
                                ? value.toFixed(4)
                                : value))))))),
                    type === "afterSaved" && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(core_1.Grid, { container: true, spacing: 1, sx: { mb: 2 } },
                            react_1.default.createElement(core_1.Grid, { item: true, xs: 4, className: styles.labelText },
                                react_1.default.createElement(core_1.Typography, { style: { marginTop: 4, marginBottom: 1 } }, "URL")),
                            react_1.default.createElement(core_1.Grid, { item: true, xs: 8 },
                                react_1.default.createElement(core_1.Typography, { className: styles.valueText }, savedDetails ? savedDetails.url : ''))),
                        react_1.default.createElement(core_1.Grid, { container: true, spacing: 1, sx: { mb: 2 }, className: styles.labelText },
                            react_1.default.createElement(core_1.Grid, { item: true, xs: 4 },
                                react_1.default.createElement(core_1.Typography, { sx: { marginTop: "4px", marginBottom: 1 } }, "Inference Endpoint")),
                            react_1.default.createElement(core_1.Grid, { item: true, xs: 8 },
                                react_1.default.createElement(core_1.Typography, { className: styles.valueText }, savedDetails ? savedDetails.inference_endpoint : ''))))),
                    react_1.default.createElement(core_1.Grid, { container: true },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 4, className: styles.labelText },
                            react_1.default.createElement(core_1.Typography, { style: { marginTop: "4px", marginBottom: 1 } }, "Description")),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 8 },
                            react_1.default.createElement(core_1.Typography, { className: styles.valueText }, description && description.trim() ? description : "No Description"))),
                    react_1.default.createElement(core_1.Grid, { container: true, spacing: 1, sx: { mb: 2 }, className: styles.labelText },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(core_1.Typography, { style: { marginTop: "4px", marginBottom: 1 } }, "Data Format for Inference")),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sx: { ml: 2 } },
                            react_1.default.createElement(core_1.Typography, { component: "pre", style: { whiteSpace: 'pre-wrap', backgroundColor: '#F5F5F5', padding: 2, borderRadius: 1, fontSize: 14 } }, savedDetails ? JSON.stringify(savedDetails.dataformat_for_inference, null, 2) : '')),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { display: 'flex', justifyContent: 'flex-end', mt: 2, paddingTop: "32px" } }, type === "afterSaved" &&
                            react_1.default.createElement(core_1.Button, { variant: "outlined", color: "primary", startIcon: react_1.default.createElement(Icons_1.ClipboardIcon, null), onClick: handleCopy, sx: {
                                    color: 'primary.main',
                                    borderColor: 'primary.main',
                                    '&:hover': {
                                        borderColor: 'primary.dark',
                                    },
                                } }, "Copy"))))))));
}
exports.ModelInfoModal = ModelInfoModal;
//# sourceMappingURL=modelInfoModal.js.map